import defaultFields from 'store/Workspace/fields';
import { updatePreferences } from 'store/Preferences/actions';
import { selectFields } from './selectors';
import { cloneDeep } from 'lodash';

export function setFieldVisibility (field, value) {
  return async (dispatch, getState) => {
    let workspaces_table = cloneDeep(selectFields(getState()));

    if (!workspaces_table) workspaces_table = { ...defaultFields };
    if (!workspaces_table[field].locked) {
      workspaces_table[field].visible = value;

      if (value) workspaces_table[field].order = Object.keys(workspaces_table).filter((key) => workspaces_table[key].visible).length;
      else {
        let cont = 1;
        Object.keys(workspaces_table)
          .filter(f => workspaces_table[f].visible && f !== field)
          .sort((a, b) => (workspaces_table[a].order - workspaces_table[b].order))
          .forEach(f2 => {
            workspaces_table[f2].order = cont;
            cont++;
          });
      }

      dispatch(updatePreferences({ workspaces_table }));
    }
  };
}

export function setNewOrderColumns (columns) {
  return async (dispatch, getState) => {
    let workspaces_table = cloneDeep(selectFields(getState()));

    if (!workspaces_table) workspaces_table = { ...defaultFields };

    const fixedColumnsCount = Object.values(workspaces_table).filter(col => col.locked).length;

    columns.forEach((column, index) => {
      if (column && !workspaces_table[column].locked) {
        workspaces_table[column].order = index + 1 + fixedColumnsCount;
      }
    });

    dispatch(updatePreferences({ workspaces_table }));
  };
}

export function resetDefault () {
  return async (dispatch) => {
    dispatch(updatePreferences({ workspaces_table: defaultFields }));
  };
}
